import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type {
  CryptoAddressCheckResponse,
  GetSavedCryptoAddressesResponse,
} from '../model';

const getSavedCryptoAddresses = async (
  networkName: string,
  options?: RequestHandlerOptions
) => {
  const request = () =>
    apiClient.get(`/operations/crypto/${networkName}/template`);
  const response = await handleRequest<GetSavedCryptoAddressesResponse>(
    request,
    options
  );
  return response.data;
};

const checkCryptoAddress = async (
  network: string,
  address: string
): Promise<CryptoAddressCheckResponse> => {
  const response = await apiClient.get<CryptoAddressCheckResponse>(
    `/operations/crypto/${network}/check/${address}`
  );
  return response.data;
};

export { getSavedCryptoAddresses, checkCryptoAddress };
